import { styled, Typography } from "@mui/material";
import { CodeIcon } from "@phosphor-icons/react/dist/csr/Code";
import { FC } from "react";
import IconCopy from "../common/IconCopy";

const CodeIconMui = styled(CodeIcon)(({ theme }) => ({
  color: theme.palette.surfaceLight50.main,
  width: "25px",
  height: "25px",
}));

interface IIconCopyToClipboard {
  id: string;
  type: string;
}

const TypographyGrey = styled(Typography)(({ theme }) => ({
  color: theme.palette.text30.main,
  fontSize: 11,
  marginLeft: "10px",
  marginRight: "10px",
}));

// TODO: Rename. This has nothing to do with IconCopy. It's not a common UI component.
const IconCopyToClipboard: FC<IIconCopyToClipboard> = ({ id, type }) => {
  return (
    <>
      <CodeIconMui />
      <TypographyGrey>{id}</TypographyGrey>
      <IconCopy tooltip={`${type}: ${id}`} clipboard={`${type}: ${id}`} />
    </>
  );
};

export { IconCopyToClipboard };
